<template>
  <div>
    <el-form
      :inline="true"
      ref="formRef"
      :model="ruleForm"
      :rules="rules"
      class="userForm"
      label-width="100px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="名称" prop="careLibraryName">
            <el-input
              style="width: 100%"
              v-model="ruleForm.careLibraryName"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="类型" prop="careLibraryType">
            <h-selectcode
              type="listLibraryType"
              v-model="ruleForm.careLibraryType"
              placeholder="请选择类型"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="comment">
            <el-input
              v-model="ruleForm.comment"
              maxlength="30"
              placeholder="备注"
              show-word-limit
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div class="form-button">
          <el-button type="primary" @click="onSubmit(formRef)">提交</el-button>
          <el-button @click="cancel">返回</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref, watchEffect } from "vue";
// import { ElMessageBox } from "element-plus";
import { ElMessage } from 'element-plus';
import { peoplesave, peopleupdate } from "@/api/communityCare/communityCareApi.js";
import _ from 'lodash';
export default defineComponent({
  props: {
    status: {
      type: Number,
      default: 1
    },
    form: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, context) {
    const formRef = ref(null);
    const state = reactive({
      ruleForm: {
        careLibraryName: "",
        careLibraryType: "",
        comment: ""
      },
      rules: {
        careLibraryName: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          }
        ],
        careLibraryType: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'blur'
          }
        ]
      }
    });
    const methods = {
      onSubmit(formEl) {
        if (!formEl) return;
        formEl.validate(async (valid) => {
          if (valid) {
            let res = {};
            if (props.status === 1) {
              res = await peoplesave(state.ruleForm);
            } else {
              res = await peopleupdate(state.ruleForm);
            }
            if (res.code === 0) {
              state.dialogVisible = false;
              ElMessage.success('操作成功');
            }
            methods.cancel();
          } else {
            console.log('error submit!');
            return false;
          }
        });
      },
      cancel() {
        context.emit('cancel');
      }
    };
    watchEffect(() => {
      if (props.status === 2) {
        const form = { ...state.ruleForm, ...props.form };
        state.ruleForm = _.cloneDeep(form);
      } else {
        const form = {
          careLibraryName: "",
          careLibraryType: "",
          comment: ""
        };
        state.ruleForm = _.cloneDeep(form);
      }
    });
    return {
      ...toRefs(state),
      ...methods,
      formRef
    };
  }
});
</script>
<style lang="scss" scoped>
.userForm {
  width: 100%;
  max-height: 500px;
  overflow: auto;
  .el-form-item {
    width: 90%;
    .form-button {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-left: 50px;
    }
  }
}
</style>